<style scoped>  

  @media only screen and (max-width: 767px) {
    .search-button {
      margin-top: 16px;
    }
  }

  @media only screen and (min-width: 768px) {
    .search-button {
      margin-top: 24px;
    }
  }

</style>

<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form" @submit.prevent="onSearch()">      
      <div class="fields">
        <div class="three wide field">
          <label>Data Inicial <span class="red text">*</span></label>
          <div id="quotations-start-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <label>Data Final <span class="red text">*</span></label>
          <div id="quotations-end-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <button type="submit" class="ui basic blue icon button search-button" :class="{ loading }">
            <i class="search icon"></i>
            Pesquisar
          </button>
        </div>
      </div>
    </form>

    <div v-if="quotations && quotations.length > 0" class="ui segment animated fadeIn m-t-20">
      <table class="ui very basic celled selectable tablet stackable table">
        <thead class="desktop-only">
          <tr>
            <th>Status</th>
            <th>Número</th>
            <th>Data</th>            
            <th>Representante</th>
            <th>Total Sugerido</th>
            <th>Total Aprovado</th>            
          </tr>
        </thead>
        <tbody>
          <tr v-for="quotation in quotations" class="clickable" @click="onShowQuotation(quotation)">
            <td style="white-space: nowrap;">
              <i class="icon" :class="quotation.statusData.icon + ' ' + quotation.statusData.color"></i> 
              {{ quotation.statusData.description }}
            </td>
            <td><strong class="mobile-only">Número: </strong>{{ quotation.id }}</td>
            <td><strong class="mobile-only">Data: </strong>{{ $formatDate(quotation.date) }}</td>
            <td><strong class="mobile-only">Representante: </strong>{{ quotation.nameUser }}</td>
            <td><strong class="mobile-only">Total Sugerido: </strong>R$ {{ $formatCurrency(quotation.sugTotal) }}</td>
            <td><strong class="mobile-only">Total Aprovado: </strong>R$ {{ $formatCurrency(quotation.appTotal) }}</td>
          </tr>          
        </tbody>
      </table>
    </div>

  </div>

</template>

<script>

  import { Message, Calendar } from "@/utils"
  import QuotationService from "@/services/quotation-service"

  export default {    

    data() {
      return {
        loading: false,
        quotations: null,
      }
    },
    
    props: ["customer"],

    mounted() {

      Calendar.initInputs()
    },

    methods: {

      async onSearch() {

        let startDate = $("#quotations-start-date").calendar("get date")
        let endDate = $("#quotations-end-date").calendar("get date")

        if (!startDate || !endDate) {
          Message.info("Defina o intervalo de datas")
          return
        }

        this.loading = true

        try {

          this.quotations = await QuotationService.search({
            startDate,
            endDate,
            codeCustomer: this.customer.code,
            unitCustomer: this.customer.unit,            
          })

          this.loading = false

          if (this.quotations.length == 0)
            Message.info("Nenhum registro encontrado")
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onShowQuotation(quotation) {
        QuotationService.showQuotation(quotation.id)
      },
    },

  }

</script>

